import React from 'react';
import SectionWrapper from 'Components/SectionWrapper/SectionWrapper.js';
import imgTeamBlau from './SectionMitarbeiter/img/team_neu/Gefäßpraxis_blau.JPG';
import imgTeamBlauWebp from './SectionMitarbeiter/img/team_neu/Gefäßpraxis_blau.webp';
import imgTeamRot from './SectionMitarbeiter/img/team_neu/Gefäßpraxis_rot_Grahl.JPG';
import imgTeamRotWebp from './SectionMitarbeiter/img/team_neu/Gefäßpraxis_rot_Grahl.webp';
import { motion } from "framer-motion";
import './Leistungen.css';

const variants = {
    parent: {
        enter: {
            transition: {
                staggerChildren: 0.06,
            }
        }
    },
    title: {
        enter: { y: 0, opacity: 1 },
        exit: { y: 20, opacity: 0 }
    },
    children: {
        enter: {
            x: 0, opacity: 1, transition: {
                when: "beforeChildren",
                staggerChildren: 0.06,
            }
        },
        exit: { x: 50, opacity: 0 }
    }
};

const Leistungen = () =>
  <div>
    <SectionWrapper title="Leistungen" subtitle="Hier finden Sie eine kurze Auflistung unsere Leistungen.">
      <motion.div variants={variants.parent} className="leistungen-layout">
        <motion.div variants={variants.children} className="leistungen-block">
          <div className="leistungen-text">
            <ul className="list">
              <li>Farbduplexsonographie</li>
              <li>Systolischer Knöcheldruck</li>
              <li>Oszillographie</li>
              <li>Akrale Plethysmographie</li>
              <li>Vitalkapillarmikroskopie</li>
              <li>Lichtreflexionsrheographie</li>
              <li>Venenverschlussplethysmographie</li>
              <li>Laufbandtest</li>
              <li>Intermittierende apparative Kompressionstherapie</li>
              <li>Infusionstherapie</li>
              <li>Behandlung chronischer Wunden</li>
              <li>Behandlung des diabetischen Fußes</li>
            </ul>
          </div>
          <motion.picture variants={variants.children} className="leistungen-image-wrapper">
            <source srcSet={imgTeamRotWebp} type="image/webp" />
            <source srcSet={imgTeamRot} type="image/jpg" />
            <img className="team_image leistungen_image" alt="Team" src={imgTeamRot} />
          </motion.picture>
        </motion.div>

        <motion.div variants={variants.children} className="leistungen-block">
          <div className="leistungen-text">
            <h3>Ambulante Operationen</h3>
            <ul className="list">
              <li>Dialysezugänge: Erstanlagen und Korrekturen von arterio-venösen Fisteln (AV-Shunts)</li>
              <li>Bedarfsgerechte Krampfaderbehandlung unter medizinischen und kosmetischen Aspekten:  in Allgemein- oder Lokalanästhesie, endovenöse Radiofrequenzablation (RFA) und Lasertherapie (EVLT) , Verödungstherapie, Schaumsklerosierung</li>
              <li>Operative Wundtherapie: Debridements, Vacuumtherapie, Spalthautplastik etc.</li>
              <li>Chirurgie  der Körperoberfläche: Entfernung von Haut- und Unterhauttumoren, Abszessentlastung etc.</li>
              <li>Minoramputationen</li>
            </ul>
            <div style={{ width: "fit-content", borderRadius: "10px", cursor: "pointer", margin: "10px 10px", border: "2px solid var(--color-dark-blue)", color: "var(--color-dark-blue)", backgroundColor: "var(--color-light-blue)", padding: "15px 20px", fontWeight: "bold", fontSize: "1em" }}><a style={{ color: "var(--color-dark-blue)", textDecoration: "none" }} href="https://info-krampfader.de/im-fokus-de/419-herr-dr-axel-pflugradt-erachtet-die-elves-radial-als-eine-den-bisher-durchgefuehrten-operativen-verfahren-ebenbuertig-therapie" target="_blank" rel="noopener noreferrer">Interview ELVeS® Radial®-Lasertherapie</a></div>
          </div>
          <motion.picture variants={variants.children} className="leistungen-image-wrapper">
            <source srcSet={imgTeamBlauWebp} type="image/webp" />
            <source srcSet={imgTeamBlau} type="image/jpg" />
            <img className="team_image leistungen_image" alt="Team" src={imgTeamBlau} />
          </motion.picture>
        </motion.div>
      </motion.div>
    </SectionWrapper>
  </div>
export default Leistungen;
